import { frontendURL } from '../../../helper/URLHelper';
import MinhaLaisIndex from './pages/MinhaLaisIndex.vue';
import MeusNegociosIndex from './pages/MeusNegociosIndex.vue';
import WhatsappCatalogIndex from './pages/whatsappCatalog/WhatsappCatalogIndex.vue';
import WhatsappCatalogProduct from './pages/whatsappCatalog/WhatsappCatalogProduct.vue';
import { LAIS_AGENCY_PERMISSIONS } from '../laisRouteHelpers';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/minha-lais'),
    alias: [
      frontendURL('accounts/:accountId/configuracoes'),
      frontendURL('accounts/:accountId/conta'),
    ],
    name: 'minha_lais_index',
    component: MinhaLaisIndex,
    meta: { permissions: LAIS_AGENCY_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/meus-negocios'),
    alias: [frontendURL('accounts/:accountId/processos')],
    name: 'meus_negocios_index',
    component: MeusNegociosIndex,
    meta: { permissions: LAIS_AGENCY_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/minha-lais/whatsapp/catalog'),
    name: 'minha_lais_whatsapp_catalog_index',
    component: WhatsappCatalogIndex,
    meta: { permissions: LAIS_AGENCY_PERMISSIONS },
  },
  {
    path: frontendURL('accounts/:accountId/minha-lais/whatsapp/catalog/novo'),
    name: 'minha_lais_whatsapp_catalog_new',
    component: WhatsappCatalogProduct,
    meta: { permissions: LAIS_AGENCY_PERMISSIONS },
  },
  {
    path: frontendURL(
      'accounts/:accountId/minha-lais/whatsapp/catalog/:productId/editar'
    ),
    name: 'minha_lais_whatsapp_catalog_edit',
    component: WhatsappCatalogProduct,
    meta: { permissions: LAIS_AGENCY_PERMISSIONS },
  },
  {
    path: frontendURL(
      'accounts/:accountId/minha-lais/whatsapp/catalog/:productId'
    ),
    name: 'minha_lais_whatsapp_catalog_show',
    component: WhatsappCatalogProduct,
    meta: { permissions: LAIS_AGENCY_PERMISSIONS },
  },
];
